import { CAST, portraitPath } from './story.js';

export function renderDialogueView(root, dialogue) {
  const character = CAST[dialogue.characterId];
  const line = dialogue.lines?.[dialogue.index || 0];
  root.querySelector('#dialogue-speaker').textContent = character?.name || dialogue.speaker;
  root.querySelector('#dialogue-text').textContent = line?.[1] || dialogue.text;
  root.querySelector('#dialogue-role').textContent = character?.role || 'A voice on the road';
  root.querySelector('#dialogue-progress').textContent = dialogue.lines ? `${dialogue.index + 1} / ${dialogue.lines.length}` : 'VESPERA';
  const portrait = root.querySelector('#dialogue-portrait');
  portrait.hidden = !character;
  portrait.onerror = () => { portrait.hidden = true; };
  if (character) {
    portrait.src = portraitPath(dialogue.characterId, line?.[0]);
    portrait.alt = `${character.name}, ${line?.[0] || 'neutral'} expression`;
  }
  root.querySelector('#dialogue-next').textContent = dialogue.lines && dialogue.index < dialogue.lines.length - 1
    ? 'NEXT / SPACE' : 'RETURN TO THE ROAD';
}
